import React, { useState, useContext } from "react"
import Loader from "./loader.js"
import loadable from "@loadable/component"
import { LocationContext } from "../context/LocationContext"

import { BsFillTrashFill } from "react-icons/bs"

import styled from "styled-components"
import { displayPrice } from "@antoine-lb/business-logic"

// Loaded differently so it does not get render on SSR (it needs the `windows` object to work)
const MapboxWrapper = loadable(() => import("./mapbox/mapboxWrapper.js"), {
  fallback: <Loader />,
})

const ChooseLocationContainer = styled.div`
  input {
    font-size: 15px;
  }
`

const TakeAwayOrDelivery = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ChooseLocationButton = styled.button`
  padding: 10px;
  margin-top: 0px;
  margin-right: 20px;
  background: #732619;
  font: 400 18px Marcellus, sans-serif;
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  border: none;
  cursor: pointer;

  @media only screen and (max-width: 500px) {
    font-size: 15px;
  }
`

const DeleteLocationButton = styled.button`
  font-weight: bold;

  display: inline-block;
  background: none;
  /* margin-top: 10px; */
  font: 400 18px Marcellus, sans-serif;
  color: #732619;
  border: none;
  cursor: pointer;

  svg {
    /* margin-top: 3px; */
    margin-left: 2px;
    margin-bottom: -2px;
  }

  @media only screen and (max-width: 500px) {
    font-size: 15px;
  }
`
const SelectedLocationContainer = styled.div`
  border: 3px solid #1a0b75;
  padding: 3px;
  margin: 10px;
  margin-top: 20px;

  .selectedlocation-second-border {
    border: 2px solid #b9342d;
    padding: 20px 30px;
    /* text-align: center; */
  }
  @media only screen and (max-width: 500px) {
    font-size: 15px;
  }
`
const HighLight = {
  fontSize: "1.1em",
  color: "#732619",
}

const ExtraInfo = styled.div`
  margin-top: 20px;

  textarea {
    width: 90%;
    height: 50px;

    padding: 5px;
    border: none;
    font-size: 17px;
    font: 400 18px Marcellus, sans-serif;
    -webkit-appearance: none;
    border-radius: 1px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.24);
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.24);
  }

  @media only screen and (max-width: 500px) {
    textarea {
      height: 100px;
      font-size: 17px;
    }
  }
`

const ChooseLocation = () => {
  const {
    location,
    setLocation,
    isSelected,
    isLocationValid,
    deliveryZone,
    isTakeaway,
    notes,
    hour,
    date,
    setNotes,
    setHour,
    setDate,
  } = useContext(LocationContext)

  const [isMapOpen, toggleIsMapOpen] = useState(false)

  const takeaway_location = {
    type: "takeaway",
    zipcode: 7500000,
    commune: "Providencia",
    is_address: true,
    place_name:
      "Baco, Nueva de Lyon 113, Providencia, Región Metropolitana de Santiago 7500000, Chile",
    lon: -70.610197,
    lat: -33.420679,
  }

  return (
    <ChooseLocationContainer>
      {!isLocationValid ? (
        <TakeAwayOrDelivery>
          <h2>Donde desea recibir su pedido:</h2>
          <div>
            <ChooseLocationButton
              type="button"
              onClick={() => toggleIsMapOpen(!isMapOpen)}
            >
              Despacho a su casa
            </ChooseLocationButton>
            <ChooseLocationButton
              type="button"
              onClick={() => {
                setLocation(takeaway_location)
                toggleIsMapOpen(false)
              }}
            >
              Retiro en Baco
            </ChooseLocationButton>
          </div>
        </TakeAwayOrDelivery>
      ) : null}

      {isMapOpen ? <MapboxWrapper /> : null}
      {isSelected ? (
        <SelectedLocationContainer>
          <div className="selectedlocation-second-border">
            <span>
              <strong>Dirección Completa: </strong>
              {location.place_name}
            </span>
            <DeleteLocationButton
              onClick={() => {
                setLocation({})
                toggleIsMapOpen(false)
              }}
            >
              (Borrar direccion
              <BsFillTrashFill />)
            </DeleteLocationButton>
            <br />
            {isLocationValid ? (
              <div style={{ marginTop: "20px" }}>
                {isTakeaway ? (
                  <div>
                    <div>
                      <strong>Despacho: </strong>
                      Para llevar (no hay costos adicionales)
                    </div>
                    <div>
                      <br />
                      <hr style={HighLight} />
                      <ExtraInfo>
                        <span htmlFor="extra-info">
                          <strong>
                            Indicar la
                            <span style={HighLight}>Fecha y Hora</span> A la
                            cual quiere Retirar su pedido:
                          </strong>
                        </span>
                        <br />
                        <br />
                        <span>Hora:</span>
                        <input
                          type="text"
                          value={hour}
                          onChange={event => setHour(event.target.value)}
                        ></input>
                        <br />
                        <br />
                        <span>Fecha:</span>
                        <input
                          type="text"
                          value={date}
                          onChange={event => setDate(event.target.value)}
                        ></input>
                        <br />
                        <br />
                        <br />
                        <span>Comentarios:</span>

                        <textarea
                          id="extra-info"
                          type="text"
                          value={notes}
                          onChange={event => setNotes(event.target.value)}
                        ></textarea>
                      </ExtraInfo>
                    </div>
                  </div>
                ) : (
                  <div>
                    {deliveryZone ? (
                      <div>
                        <strong>Despacho: </strong>$
                        {displayPrice(deliveryZone.price_in_cent)} (
                        {deliveryZone.distanceInKm}km)
                        <ExtraInfo>
                          <span htmlFor="extra-info">
                            <hr style={HighLight} />
                            <strong>
                              Indicar la{" "}
                              <span style={HighLight}>Fecha y Hora</span> a la
                              cual desea recibir su pedido. <br />
                              <p>
                                Si se encuentra en un condominio; indicar el{" "}
                                <span style={HighLight}>
                                  Numero de Departamento
                                </span>{" "}
                                y todo lo necesario para facilitar su entrega.
                              </p>
                            </strong>
                          </span>

                          <textarea
                            id="extra-info"
                            type="text"
                            value={notes}
                            onChange={event => setNotes(event.target.value)}
                          ></textarea>
                        </ExtraInfo>
                      </div>
                    ) : (
                      <div>
                        Despacho:
                        <strong>
                          Disculpenos pero no hacemos delivery en esa zona,
                          contactenos al +56959157833 para mas informacion
                        </strong>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div>
                Disculpenos pero no es una direccion valida, si encuentra
                problemas contactenos al{" "}
                <span style={HighLight}>+56959157833</span>
              </div>
            )}
          </div>
        </SelectedLocationContainer>
      ) : null}
    </ChooseLocationContainer>
  )
}

export default ChooseLocation
